import { SetPlaidCredentialsRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useSetPlaidCredentials() {
  const [saving, setSaving] = useState(false);

  async function setPlaidCredentials(request: SetPlaidCredentialsRequest) {
    try {
      setSaving(true);
      const res = await api.postSetPlaidCredentials(request);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setSaving(false);
    }
  }

  return { saving, setPlaidCredentials };
}
